import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import * as React from 'react';

interface IOmnibarTitleProps {
    children: React.ReactNode;
}

export const OmnibarTitle = (props: IOmnibarTitleProps) => (
    <Flex css={{ px: '$4' }}>
        <Box font="gray500 textSm medium">{props.children}</Box>
    </Flex>
);
